<template>
  <v-app>
    <v-app-bar
      app
      color="white"
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="./assets/logo.png"
          transition="scale-transition"
          width="40"
          @click="link('/')"
          :style="{ cursor: 'pointer'}"
        />

        <div @click="link('/')" :style="{ cursor: 'pointer'}" :class='[this.$vuetify.breakpoint.smAndDown ? "h4" : "h1"]'>Fap Interactive</div>
      </div>

      <v-spacer></v-spacer>

      <div v-if="!this.$vuetify.breakpoint.smAndDown" class="d-flex align-center">
        <v-form @submit.prevent="searchCards">
          <v-text-field
            filled
            rounded
            dense
            hide-details
            solo
            label="Search"
            prepend-inner-icon="mdi-magnify"
            v-model="searchString"
            clearable
            @click.clear="link('/')"
          ></v-text-field>
        </v-form>
      </div>

      <v-spacer></v-spacer>

      <v-btn small color="warning" rounded href='https://www.patreon.com/bePatron?u=36618477' target="_blank">
        Become a Patron
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-footer
    color="white"
    padless
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-btn
        v-for="footerLink in footerLinks"
        :key="footerLink.title"
        color="purple"
        text
        rounded
        class="my-2"
        @click="link(footerLink.route)"
      >
        {{ footerLink.title }}
      </v-btn>
      <v-col
        class="white py-4 text-center"
        cols="12"
      >
        {{ new Date().getFullYear() }} — <strong>Fap Interactive</strong> V0.4
      </v-col>
    </v-row>
  </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {

  },

  data: () => ({
    footerLinks: [
      {
        title: "Change Log",
        route: "changelog"
      },
      {
        title: "Upcoming Changes",
        route: "todo"
      },
      {
        title: "Supporters",
        route: "supporters"
      },
      {
        title: "Contact Us",
        route: "contact"
      },
    ],
    searchString: "",
  }),
  methods:{
    link: function(route){
      this.$router.push(route)
    },
    searchCards() {
      if(this.searchString){
        this.$store.dispatch('searchCards', this.searchString).then(() => {
          this.$router.push('search');
        })
      } else {
        this.$router.push('/')
      }
    }
  }
};
</script>
